<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="41">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="场次">
                            <c-input name="auction_batch_no"></c-input>
                        </m-search-item>
                        <m-search-item label="报告时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="80" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.detail.open(data)">详情</c-table-button>
                    </template>
                </c-table-column>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #deal_amount="{data}">
                    <span style="color: #e53e3e;">{{formatPrice(data.deal_amount)}}</span>
                </template>

                <template #gross_profit="{data}">
                    <span style="color: #e53e3e;">{{formatPrice(data.gross_profit)}}</span>
                </template>
            </view-list>
            <erp-auction-stat-report-detail ref="detail"></erp-auction-stat-report-detail>
        </module>
    </page>
</template>

<script>
import ErpAuctionStatReportDetail from './components/auction_stat_report_detail.vue';

export default {
    name: 'erp_auction_stat_report',
    components: {ErpAuctionStatReportDetail},
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        }
    }
};
</script>

<style scoped>
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
</style>
